import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppComponentBase } from './app.component.base';

@Component({
	selector: 'bas-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class AppComponent extends AppComponentBase {
}
